export const getActiveDialCode = () => {
  return '+373';
};

export const getActiveCountryCode = () => {
  return 'MD';
};
